import { Finish } from "./Finish.tsx";

export const Finishes = () => {
  return (
    <div className="finishes-wrapper">
      <span className="content-padding h2 centered top-padding bottom-padding-extra-large">
        Finishes
      </span>
      <div className="content-padding centered column">
        <Finish
          title="Full Char (Crocodile)"
          description="This finish is the most traditional finish. A layer of char left on the surface of the timber adds the most protection from the the elements. Stained black with our specially selected stain hardens the surface and provide a long lasting durable and stunning deep black textured finish."
          imageUrl="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-15_orig.jpg"
          id="full-char"
        />

        <Finish
          title="Charred and Brushed"
          description="This finish has all the benefits of charred timber, while being a bit more sleek. Naturally dark brown with Black grain. Great for interior and exterior applications and can be stained our selection of colours for the added effect to your style."
          imageUrl="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-17_orig.jpg"
          id="charred-and-brushed"
        />

        <Finish
          title="Double Brushed (Snake Skin)"
          description="​This Finish is striking and full of textures and colour. While it can look elegant against the other two finishes, giving a contrast between light and dark. We mostly recommend this finish for gable ends, feature walls or decorative art pieces."
          imageUrl="https://charproof.weebly.com/uploads/1/4/9/1/149102767/unnamed-18_orig.jpg"
          id="double-brushed"
        />
      </div>
    </div>
  );
};
